import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReduxStore } from 'src/ducks';

const env = process.env.REACT_APP_ENV;

const CdpAnalytics: React.FC = () => {
  const user = useSelector((state: ReduxStore) => state.user.data);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = env === 'production' ? 'https://x534.edhub.ama-assn.org/script.js' : 'https://ama.sb.blueconic.net/script.js';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [user]);

  return (
    <>
      <div className="hide tagmanagervalue" data-attribute="customerId" data-value={user.advantageCustomerNumber} data-type="string"></div>
      <div className="hide tagmanagervalue" data-attribute="tamId" data-value={user.tamId} data-type="string"></div>
      <div className="hide tagmanagervalue" data-attribute="ehrId" data-value={user.id} data-type="string"></div>
      <div className="hide tagmanagervalue" data-attribute="productName" data-value="Ed Hub Learner Portal" data-type="string"></div>
    </>
  );
};

export default CdpAnalytics;
